{
    "SCOPEASSIGNMENT_CME": "CME:",
    "SCOPEASSIGNMENT_FilterRecursively": "Filter Recursively:",
    "SCOPEASSIGNMENT_TelServer": "Telephony Server:",
    "SCOPEASSIGNMENT_Partition": "Partition:",
    "NAME": "ScopeAssignment"
}